module.exports = __webpack_public_path__ + "img/cross-circled.f5ce98c1.svg";